import { render, staticRenderFns } from "./ItemCoordinateControl.vue?vue&type=template&id=753b7568&scoped=true&"
import script from "./ItemCoordinateControl.vue?vue&type=script&lang=js&"
export * from "./ItemCoordinateControl.vue?vue&type=script&lang=js&"
import style0 from "./ItemCoordinateControl.vue?vue&type=style&index=0&id=753b7568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b7568",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('753b7568', component.options)
    } else {
      api.reload('753b7568', component.options)
    }
    module.hot.accept("./ItemCoordinateControl.vue?vue&type=template&id=753b7568&scoped=true&", function () {
      api.rerender('753b7568', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/ScreenEditor/Toolbar/ItemCoordinateControl.vue"
export default component.exports